module.exports = __webpack_public_path__ + "static/smn_logo4-1b16c7a1223b5d2c017b8c385dba2b72.png";